import { Enums } from "../common"
import { IOpData, IOpChangeState } from "../util/interfaces"
import { OpDataType } from "./op-data-type"

export class OpDeviceTypeData
    implements IOpData, IOpChangeState
{
    // #region Properties

    public idDeviceTypeData: number
    public idDeviceType: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // #endregion

    // #region NavigationProperties

    public dataType: OpDataType

    // #endregion

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #region IOpData implementation

    public get idData(): number { return this.idDeviceTypeData }
    public set idData(value: number) { this.idDeviceTypeData = value }

    public get indexNBR(): number { return this.indexNbr }
    public set indexNBR(value: number) { this.indexNbr = value }

    // #endregion

    // #region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // #endregion

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idDeviceTypeData = opObj.ID_DEVICE_TYPE_DATA
            this.idDeviceType = opObj.ID_DEVICE_TYPE
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DEVICE_TYPE_DATA: this.idDeviceTypeData,
            ID_DEVICE_TYPE: this.idDeviceType,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,

            OpState: this.opState,
        }
    }
}